import React, { Component } from "react";

import classNames from "classnames";

import { DialogTitle } from "@material-ui/core";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";

import { dialogTheme } from "js/react/materialThemeOverrides";
import { withFirebaseUser } from "js/react/views/Auth/FirebaseUserContext";
import sanitizeRelativeUrl from "common/utils/sanitizeRelativeUrl";

import stripeProducts from "common/stripeProducts";
import { BeautifulDialog, DialogContent } from "js/react/components/Dialogs/BaseDialog";
import Spinner from "js/react/components/Spinner";

import PaymentForm from "./PaymentForm";

import "css/billing.scss";

export class RenewSubscription extends Component {
    constructor(props) {
        super();
        this.state = {
            billingInterval: props.defaultBillingInterval ?? "year",
            successfulPurchase: false,
            isSubmitting: false,
            alreadySubscribed: false
        };
    }

    refreshApp = () => {
        setTimeout(() => {
            const continueUrl = sanitizeRelativeUrl(new URLSearchParams(window.location.search).get("continue") ?? "/");
            window.location.href = continueUrl;
        }, 50);
    };

    handleOnBeforeCharge = () => {
        this.setState({ isSubmitting: true });
    };

    handleOnFailure = () => {
        this.setState({ isSubmitting: false });
    };

    handlePromoChanged = promo => {
        this.setState({ promo });
    };

    render() {
        const { subscription, teamName, orgId, closeDialog, hideBackdrop, style } = this.props;
        const { interval: billingInterval } = subscription;
        const { isSubmitting } = this.state;
        const productName = Object.entries(stripeProducts).find(([, product]) => product.productId === subscription.product)[0];
        const { amount, planId } = stripeProducts[productName].plans.find(plan => plan.isDefault && plan.interval === billingInterval);

        return (
            <MuiThemeProvider theme={dialogTheme}>
                <BeautifulDialog
                    preventClose={isSubmitting}
                    closeDialog={closeDialog}
                    hideBackdrop={hideBackdrop}
                    style={style}
                >
                    <DialogTitle>Reactivate canceled account</DialogTitle>
                    <DialogContent>
                        <div
                            className={classNames({
                                disabled: isSubmitting
                            })}
                        >
                            {isSubmitting && <Spinner />}
                            <PaymentForm
                                organizationId={orgId}
                                teamName={teamName}
                                seatCount={subscription.quantity}
                                productName={productName}
                                billingInterval={billingInterval}
                                productPrice={planId}
                                amount={amount}
                                customerType={productName}
                                onSuccess={() => {
                                    this.refreshApp();
                                }}
                                isReactivating={true}
                                onBeforeCharge={this.handleOnBeforeCharge}
                                onFailure={this.handleOnFailure}
                                submitLabel="Reactivate account"
                                buttonStyle={{ marginTop: 30 }}
                                hasTakenTrial={true}
                                onPromoChanged={this.handlePromoChanged}
                            />
                        </div>
                    </DialogContent>
                </BeautifulDialog>
            </MuiThemeProvider>
        );
    }
}

export default withFirebaseUser(RenewSubscription);
